import React from 'react';
import { Box, Container } from '@mui/material';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box display="flex" minHeight="100vh" flexDirection="column">
      <Navbar />
      <Container maxWidth={false} disableGutters sx={{ flex: 1, py: 0, px: 0 }}>
        {children}
      </Container>
      <Footer />
    </Box>
  );
};

export default Layout;
